import { render, staticRenderFns } from "./TestAction.vue?vue&type=template&id=67cb7502"
import script from "./TestAction.vue?vue&type=script&lang=js"
export * from "./TestAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports